module.exports = __webpack_public_path__ + "media/3-1-3 Chinese New Year's Eve.1b8377d8.mp4";